import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQueries, useQueryClient } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getSites from "../http/getSites";
import { Site } from "../models/site";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSites = (
  siteIds: string[],
  userOrgId?: string,
  testOrgId?: string | null
) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const queryClient = useQueryClient();

  const params = new URLSearchParams(window.location.search);
  if (!testOrgId) {
    testOrgId = params.get("testOrgId");
  }

  const chunk = <T>(arr: T[], chunkSize: number): T[][] => {
    const chunks: T[][] = [];
    const tmp = [...arr];
    while (tmp.length) {
      chunks.push(tmp.splice(0, chunkSize));
    }
    return chunks;
  };
  return useQueries({
    queries: chunk([...siteIds].sort(), 50)
      .map((siteIdsChunk) => siteIdsChunk.join(","))
      .map((siteIdsChunkStr) => {
        return {
          queryKey: ["sites", siteIdsChunkStr],
          queryFn: async () =>
            getSites(
              await getAuthTokenBlocking(getToken, relogin),
              siteIdsChunkStr,
              await getUserOrgId(getClaim, userOrgId),
              testOrgId
            ),
          staleTime: 5 * 60 * 1000,
          onSuccess: (data: { sites: Site[] }) => {
            data.sites.forEach((site: Site) => {
              Object.freeze(site);
              queryClient.setQueryData(["site", site.id], { site });
            });
          },
        };
      }),
  });
};

export default useSites;
